import { Card } from "antd";
import LoginBackground from "./components/loginBackground/LoginBackground";
import styles from "./LoginWrapper.module.less";

export const LoginWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={styles.login}>
      <LoginBackground />

      <Card style={{ width: "25vw" }} className={styles.loginContainer}>
        {children}
      </Card>
    </div>
  );
};
